(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/hooks/use-draws.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/hooks/use-draws.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext,
  useRef = _React.useRef,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const loadDrawByProduct = svs.components.sport.drawsRedux.actions.loadDrawByProduct;
const _svs$components$tipse = svs.components.tipsen,
  makeSelectDrawsByDrawNumber = _svs$components$tipse.selectors.makeSelectDrawsByDrawNumber,
  EngineProviderContext = _svs$components$tipse.engine.EngineProviderContext;
const useMemoizedSelector = svs.components.lbUtils.hooks.useMemoizedSelector;

const useDraws = _ref => {
  let _drawNumbers = _ref.drawNumbers,
    _ref$productId = _ref.productId,
    _productId = _ref$productId === void 0 ? null : _ref$productId;
  const _useContext = useContext(EngineProviderContext),
    currentEngine = _useContext.currentEngine;
  const _currentEngine$drawPr = _slicedToArray(currentEngine.drawProductIds, 1),
    productIdByEngine = _currentEngine$drawPr[0];
  const productId = _productId || productIdByEngine;
  const prevDrawNumbers = useRef(_drawNumbers);
  const _useState = useState(_drawNumbers),
    _useState2 = _slicedToArray(_useState, 2),
    drawNumbers = _useState2[0],
    setDrawNumbers = _useState2[1];
  useEffect(() => {
    const isSame = _drawNumbers.every((drawNumber, index) => drawNumber === prevDrawNumbers.current[index]);
    if (!isSame || _drawNumbers.length !== prevDrawNumbers.current.length) {
      prevDrawNumbers.current = _drawNumbers;
      setDrawNumbers(_drawNumbers);
    }
  }, [_drawNumbers]);
  const selectDraws = useMemoizedSelector(makeSelectDrawsByDrawNumber, productId, drawNumbers);
  const draws = useSelector(selectDraws);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadDrawByProduct({
      productId,
      drawNumber: drawNumbers,
      currentEngine
    }));
  }, [dispatch, productId, drawNumbers, currentEngine]);
  return draws;
};
setGlobal('svs.components.tipsen.routeCompetition.useDraws', useDraws);

 })(window);